import Link from 'next/link';
import {Swiper, SwiperSlide} from '@/_application/core/components/ui/slider';
import {Scrollbar} from 'swiper/modules';
import {HomepageFeaturedBlock} from '__generated__/__types__';
import {ORDER_DOCS} from '@/framework/static/filter-attribute-code-value-type';

const ProductAttributesSwiper = ({
    data,
    attributeIndex,
    canonicalUrl,
    isQuantitativeAttribute = false,
}: {
    data: HomepageFeaturedBlock;
    attributeIndex: number;
    canonicalUrl: string;
    isQuantitativeAttribute?: boolean;
}) => {
    const attribute = data?.product_attributes?.[attributeIndex];
    const slidesPerView = isQuantitativeAttribute ? 6 : 5;
    const spaceBetween = isQuantitativeAttribute ? 12 : 0;

    return (
        <Swiper
            direction="horizontal"
            slidesPerView={slidesPerView}
            spaceBetween={spaceBetween}
            scrollbar={{
                el: '.swiper-scrollbar',
                draggable: true,
                dragSize: 'auto',
            }}
            modules={[Scrollbar]}
            className="pb-5!">
            {attribute?.options
                ?.filter(item => item?.value !== ORDER_DOCS)
                ?.map(item => {
                    const hrefValue = `${canonicalUrl}?${attribute?.attribute_code}=${encodeURIComponent(item?.label!)}`;

                    return (
                        <SwiperSlide key={item?.label} className={'border-r border-KPZ_Gray_05 last:border-r-0'}>
                            <Link
                                href={hrefValue}
                                className="mr-3 flex items-center justify-center text-center text-sm text-KPZ_Gray-30 transition-colors hover:text-KPZ_Orange-30 lg:text-base">
                                {item?.value}
                            </Link>
                        </SwiperSlide>
                    );
                })}

            <div className="swiper-scrollbar"></div>
        </Swiper>
    );
};

export default ProductAttributesSwiper;
